var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row news H_img_V_Title_Lead m-0",
      class: { "video-play-icon": _vm.post.format === 4 },
    },
    [
      _c("div", { staticClass: "col-5 pl-0 pr-3" }, [
        _c("a", { attrs: { href: _vm.post.postUrl } }, [
          _c("div", { staticClass: "img-wrap" }, [
            _c("img", {
              attrs: {
                src: _vm.post.principalImage.url,
                alt: _vm.post.principalImage.alt,
                title: _vm.post.principalImage.title,
              },
            }),
          ]),
          _vm._v(" "),
          _vm.post.sponsoredText
            ? _c("div", {
                staticClass: "sponsored",
                domProps: { innerHTML: _vm._s(_vm.post.sponsoredText) },
              })
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-7 pl-3 pr-3" }, [
        _c("a", {
          staticClass: "kicker",
          class: _vm.post.section.className,
          attrs: { href: _vm.post.postUrl },
          domProps: { innerHTML: _vm._s(_vm.post.header) },
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "date-news",
          domProps: { innerHTML: _vm._s(_vm.postDate) },
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "tt" }, [
          _c("a", {
            class: _vm.post.section.className,
            attrs: { href: _vm.post.postUrl },
            domProps: { innerHTML: _vm._s(_vm.post.title) },
          }),
        ]),
        _vm._v(" "),
        _vm.post.subTitle
          ? _c("span", {
              staticClass: "subtitle",
              domProps: { innerHTML: _vm._s(_vm.post.subTitle) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.post.lead) } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }